import type { CSSProperties } from 'react';
import { botAccountDisplayName } from '../../lib/utils.js';

interface BotAccountBadgeProps {
  botWechatRecordId: number;
  botNickname?: string | null;
  prefix?: string;
}

type AccountBadgeStyle = CSSProperties & { '--account-hue': number };

export function BotAccountBadge({
  botWechatRecordId,
  botNickname,
  prefix = '',
}: BotAccountBadgeProps) {
  const label = botAccountDisplayName({ botNickname, botWechatRecordId });
  const style: AccountBadgeStyle = { '--account-hue': accountHue(botWechatRecordId) };

  return (
    <span className="bot-account-badge" style={style} title={`${prefix}${label} (#${botWechatRecordId})`}>
      {prefix}{label}
    </span>
  );
}

function accountHue(botWechatRecordId: number): number {
  const hues = [205, 155, 28, 188, 330, 260];
  return hues[Math.abs(botWechatRecordId) % hues.length];
}
